import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSubtaskIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.797 6.14h3.797M2.532 3.672h2.531M3.797 3.672v6.801c0 .164.067.322.185.438a.64.64 0 0 0 .448.18h3.164M12.023 4.906H8.227a.626.626 0 0 0-.633.619V6.76c0 .342.283.619.633.619h3.796c.35 0 .633-.277.633-.619V5.525a.626.626 0 0 0-.633-.619"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.023 9.852H8.227a.626.626 0 0 0-.633.618v1.236c0 .342.283.619.633.619h3.796c.35 0 .633-.277.633-.618V10.47a.626.626 0 0 0-.633-.618"
    />
  </svg>
);
export default SvgSubtaskIcon;
